import styled from 'styled-components'

export const SecurityLogosWrapper = styled.div`
  display: flex;
  justify-content: space-around;
`
